import { EXPRESSIONS } from "../components/layers/variables/expressions";
import { CUSTOMIZABLE_VALUES, DEFAULT_STYLING, } from "../components/layers/variables/layerStylingValues";
import { getDeepestObjectValues } from "../utils/helpers";
import { getIndoorGeoJSONProperties } from "../components/layers/properties/indoorGeoJSON.properties";
import { getBuildingGeoJSONProperties } from "../components/layers/properties/buildingPolygon.properties";
import { getMaskProperties } from "../components/layers/properties/misc.properties";
export const showObjectCondition = ["!=", ["get", "showObject"], false];
export var INDOORGEOJSONS_LAYERS;
(function (INDOORGEOJSONS_LAYERS) {
    INDOORGEOJSONS_LAYERS["cu_rooms_geojson"] = "cu_rooms_geojson";
    INDOORGEOJSONS_LAYERS["cu_glassrooms_geojson"] = "cu_glassrooms_geojson";
    INDOORGEOJSONS_LAYERS["cu_outlines_geojson"] = "cu_outlines_geojson";
    INDOORGEOJSONS_LAYERS["cu_ground_geojson"] = "cu_ground_geojson";
    INDOORGEOJSONS_LAYERS["cu_rooms_geojson_temp"] = "cu_rooms_geojson_temp";
    INDOORGEOJSONS_LAYERS["cu_glassrooms_geojson_temp"] = "cu_glassrooms_geojson_temp";
    INDOORGEOJSONS_LAYERS["cu_outlines_geojson_temp"] = "cu_outlines_geojson_temp";
    INDOORGEOJSONS_LAYERS["cu_ground_geojson_temp"] = "cu_ground_geojson_temp";
    INDOORGEOJSONS_LAYERS["cu_rooms_labels"] = "cu_rooms_labels";
    INDOORGEOJSONS_LAYERS["cu_rooms_labels_temp"] = "cu_rooms_labels_temp";
})(INDOORGEOJSONS_LAYERS || (INDOORGEOJSONS_LAYERS = {}));
export var BUILDING_LAYERS;
(function (BUILDING_LAYERS) {
    BUILDING_LAYERS["cu_buildings_geojson"] = "cu_buildings_geojson";
    BUILDING_LAYERS["cu_buildings_geojson_temp"] = "cu_buildings_geojson_temp";
    BUILDING_LAYERS["cu_buildings_labels"] = "cu_buildings_labels";
    BUILDING_LAYERS["cu_buildings_labels_temp"] = "cu_buildings_labels_temp";
    BUILDING_LAYERS["cu_buildings_persistent_geojson"] = "cu_buildings_persistent";
    BUILDING_LAYERS["cu_buildings_persistent_temp"] = "cu_buildings_persistent_temp";
})(BUILDING_LAYERS || (BUILDING_LAYERS = {}));
export var MISC_LAYERS;
(function (MISC_LAYERS) {
    MISC_LAYERS["cu_maskings"] = "cu_maskings";
    MISC_LAYERS["cu_maskings_temp"] = "cu_maskings_temp";
})(MISC_LAYERS || (MISC_LAYERS = {}));
export var INDOORGEOJSONS_SOURCES;
(function (INDOORGEOJSONS_SOURCES) {
    INDOORGEOJSONS_SOURCES["cu_rooms"] = "cu_rooms";
    INDOORGEOJSONS_SOURCES["cu_roomsLabels"] = "cu_roomsLabel";
    INDOORGEOJSONS_SOURCES["cu_glassRooms"] = "cu_glassRooms";
    INDOORGEOJSONS_SOURCES["cu_outlines"] = "cu_outlines";
    INDOORGEOJSONS_SOURCES["cu_ground"] = "cu_ground";
    INDOORGEOJSONS_SOURCES["cu_rooms_temp"] = "cu_rooms_temp";
    INDOORGEOJSONS_SOURCES["cu_glassRooms_temp"] = "cu_glassRooms_temp";
    INDOORGEOJSONS_SOURCES["cu_outlines_temp"] = "cu_outlines_temp";
    INDOORGEOJSONS_SOURCES["cu_ground_temp"] = "cu_ground_temp";
})(INDOORGEOJSONS_SOURCES || (INDOORGEOJSONS_SOURCES = {}));
export var BUILDING_SOURCES;
(function (BUILDING_SOURCES) {
    BUILDING_SOURCES["cu_buildings"] = "cu_buildings";
    BUILDING_SOURCES["cu_buildings_temp"] = "cu_buildings_temp";
    BUILDING_SOURCES["cu_buildings_labels"] = "cu_buildings_labels";
    BUILDING_SOURCES["cu_buildings_labels_temp"] = "cu_buildings_labels_temp";
    BUILDING_SOURCES["cu_buildings_persistent"] = "cu_buildings_persistent";
    BUILDING_SOURCES["cu_buildings_persistent_temp"] = "cu_buildings_persistent_temp";
})(BUILDING_SOURCES || (BUILDING_SOURCES = {}));
export var MISC_SOURCES;
(function (MISC_SOURCES) {
    MISC_SOURCES["cu_maskings"] = "cu_maskings";
    MISC_SOURCES["cu_maskings_temp"] = "cu_maskings_temp";
})(MISC_SOURCES || (MISC_SOURCES = {}));
export default class LayerSourceManager {
    get layersSourcesInitialized() {
        return this._layersSourcesInitialized;
    }
    // private _showBuildings: boolean = true;
    set showBuildings(value) {
        // this._showBuildings = value;
        this._map.setLayoutProperty(this._map.cuLayerIds.buildingGeoJSONs.common, "visibility", value ? "visible" : "none");
    }
    // private _showBuildingLabels: boolean = true;
    set showBuildingLabels(value) {
        // this._showBuildingLabels = value;
        this._map.setLayoutProperty(this._map.cuLayerIds.buildingLabels.common, "visibility", value ? "visible" : "none");
    }
    set showRoomLabels(value) {
        this._map.setLayoutProperty(this._map.cuLayerIds.indoorGeoJSONs.roomsLabels, "visibility", value ? "visible" : "none");
    }
    constructor(map, eventer) {
        this._layersSourcesInitialized = false;
        this.zoomRanges = {
            buildings: {
                start: 0,
                end: 16,
            },
            interior: {
                start: 16,
                end: 24,
            },
            roomLabels: {
                start: 18,
                end: 24,
            },
        };
        this.cuSourceIds = {
            indoorGeoJSONs: {
                rooms: INDOORGEOJSONS_SOURCES.cu_rooms,
                glassRooms: INDOORGEOJSONS_SOURCES.cu_glassRooms,
                outline: INDOORGEOJSONS_SOURCES.cu_outlines,
                ground: INDOORGEOJSONS_SOURCES.cu_ground,
                roomsLabel: INDOORGEOJSONS_SOURCES.cu_roomsLabels,
            },
            buildingGeoJSONs: {
                common: BUILDING_SOURCES.cu_buildings,
                persistent: BUILDING_SOURCES.cu_buildings_persistent,
            },
            buildingsLabels: {
                common: BUILDING_SOURCES.cu_buildings_labels,
            },
            maskingGeoJSONs: {
                common: MISC_SOURCES.cu_maskings,
            },
        };
        /** These ones are for editing, they are only filled when an editor is making use of this class */
        this.cuSourceIds_temporary = {
            indoorGeoJSONs: {
                rooms: INDOORGEOJSONS_SOURCES.cu_rooms_temp,
                glassRooms: INDOORGEOJSONS_SOURCES.cu_glassRooms_temp,
                outline: INDOORGEOJSONS_SOURCES.cu_outlines_temp,
                ground: INDOORGEOJSONS_SOURCES.cu_ground_temp,
                roomsLabel: INDOORGEOJSONS_SOURCES.cu_roomsLabels,
            },
            buildingGeoJSONs: {
                common: BUILDING_SOURCES.cu_buildings_temp,
                persistent: BUILDING_SOURCES.cu_buildings_persistent_temp,
            },
            buildingsLabels: {
                common: BUILDING_SOURCES.cu_buildings_labels_temp,
            },
            maskingGeoJSONs: { common: MISC_SOURCES.cu_maskings_temp },
        };
        /**
         * LayerIds of the CU layers
         */
        this.cuLayerIds = {
            indoorGeoJSONs: {
                rooms: INDOORGEOJSONS_LAYERS.cu_rooms_geojson,
                glassRooms: INDOORGEOJSONS_LAYERS.cu_glassrooms_geojson,
                outline: INDOORGEOJSONS_LAYERS.cu_outlines_geojson,
                ground: INDOORGEOJSONS_LAYERS.cu_ground_geojson,
                roomsLabels: INDOORGEOJSONS_LAYERS.cu_rooms_labels,
            },
            buildingGeoJSONs: {
                common: BUILDING_LAYERS.cu_buildings_geojson,
                persistent: BUILDING_LAYERS.cu_buildings_persistent_geojson,
            },
            buildingLabels: {
                common: BUILDING_LAYERS.cu_buildings_labels,
            },
            maskingGeoJSONs: { common: MISC_LAYERS.cu_maskings },
        };
        this.orderedLayerIds = [
            INDOORGEOJSONS_LAYERS.cu_ground_geojson,
            INDOORGEOJSONS_LAYERS.cu_outlines_geojson,
            INDOORGEOJSONS_LAYERS.cu_rooms_geojson,
            BUILDING_LAYERS.cu_buildings_geojson,
        ];
        /**
         * LayerIds of the editing CU layers
         */
        this.cuLayerIds_temporary = {
            indoorGeoJSONs: {
                rooms: INDOORGEOJSONS_LAYERS.cu_rooms_geojson_temp,
                glassRooms: INDOORGEOJSONS_LAYERS.cu_glassrooms_geojson_temp,
                outline: INDOORGEOJSONS_LAYERS.cu_outlines_geojson_temp,
                ground: INDOORGEOJSONS_LAYERS.cu_ground_geojson_temp,
                roomsLabels: INDOORGEOJSONS_LAYERS.cu_rooms_labels_temp,
            },
            buildingGeoJSONs: {
                common: BUILDING_LAYERS.cu_buildings_geojson_temp,
                persistent: BUILDING_LAYERS.cu_buildings_persistent_temp,
            },
            buildingLabels: {
                common: BUILDING_LAYERS.cu_buildings_labels_temp,
            },
            maskingGeoJSONs: { common: MISC_LAYERS.cu_maskings_temp },
        };
        this._onZoomHandler = () => {
            let currentZoom = this._map.getZoom();
            // Die Reichweite des Fades von Beginn der Visibility
            let range = 0.5;
            // Maximale Opacity (max 1)
            const maxOpacity = 1;
            // Rechnung soll nur in einem bestimmten Zoombereich erfolgen (Performance)
            // 1 ist puffer für frameskips
            if (currentZoom < this.zoomRanges.buildings.end &&
                currentZoom > this.zoomRanges.buildings.end - range - 1 &&
                this._map.getLayer(this.cuLayerIds.buildingGeoJSONs.common)) {
                let opacity = (this.zoomRanges.buildings.end - currentZoom) / range;
                // alles über 1 wird zurück auf 1 reduziert
                opacity = opacity > 1 ? 1 : opacity;
                this._map.setPaintProperty(this.cuLayerIds.buildingGeoJSONs.common, "fill-extrusion-opacity", opacity * maxOpacity);
            }
        };
        this._map = map;
        this._eventer = eventer;
    }
    init() {
        this._setSources();
        this._setLayers(true);
        this.asyncDataEvents("layersSourcesInitialized");
        this._eventer.fireEvent("layersSourcesInitialized");
    }
    asyncDataEvents(type) {
        switch (type) {
            case "layersSourcesInitialized":
                this._layersSourcesInitialized = true;
                break;
        }
    }
    /**
     * Sets the standardSources for Rendering CU Features
     */
    _setSources() {
        let initSources = getDeepestObjectValues(this.cuSourceIds).concat(getDeepestObjectValues(this.cuSourceIds_temporary));
        initSources = initSources.map((id) => {
            return {
                id: id,
                type: {
                    type: "geojson",
                    data: {
                        type: "FeatureCollection",
                        features: [],
                    },
                },
            };
        });
        initSources.forEach((s) => {
            this._map.addSource(s.id, s.type);
        });
    }
    /**
     * Sets the standardLayers for Rendering CU Features and also sets Layout/Paint properties.
     * Can be used multiple times if async stylings are updated!
     */
    // Notice: Needs loaded MapStyles. Thanks, MK.
    _setLayers(init = false) {
        const grounds = [
            {
                layerId: this.cuLayerIds.indoorGeoJSONs.ground,
                sourceId: this.cuSourceIds.indoorGeoJSONs.ground,
            },
            {
                layerId: this.cuLayerIds_temporary.indoorGeoJSONs.ground,
                sourceId: this.cuSourceIds_temporary.indoorGeoJSONs.ground,
            },
        ];
        const outlines = [
            {
                layerId: this.cuLayerIds.indoorGeoJSONs.outline,
                sourceId: this.cuSourceIds.indoorGeoJSONs.outline,
            },
            {
                layerId: this.cuLayerIds_temporary.indoorGeoJSONs.outline,
                sourceId: this.cuSourceIds_temporary.indoorGeoJSONs.outline,
            },
        ];
        const rooms = [
            {
                layerId: this.cuLayerIds.indoorGeoJSONs.rooms,
                sourceId: this.cuSourceIds.indoorGeoJSONs.rooms,
            },
            {
                layerId: this.cuLayerIds_temporary.indoorGeoJSONs.rooms,
                sourceId: this.cuSourceIds_temporary.indoorGeoJSONs.rooms,
            },
        ];
        const roomsLabels = [
            {
                layerId: this.cuLayerIds.indoorGeoJSONs.roomsLabels,
                sourceId: this.cuSourceIds.indoorGeoJSONs.roomsLabel,
            },
            {
                layerId: this.cuLayerIds_temporary.indoorGeoJSONs.roomsLabels,
                sourceId: this.cuSourceIds_temporary.indoorGeoJSONs.rooms,
            },
        ];
        const glassRooms = [
            {
                layerId: this.cuLayerIds.indoorGeoJSONs.glassRooms,
                sourceId: this.cuSourceIds.indoorGeoJSONs.glassRooms,
            },
            {
                layerId: this.cuLayerIds_temporary.indoorGeoJSONs.glassRooms,
                sourceId: this.cuSourceIds_temporary.indoorGeoJSONs.glassRooms,
            },
        ];
        const buildings = [
            {
                sourceId: this.cuSourceIds.buildingGeoJSONs.common,
                layerId: this.cuLayerIds.buildingGeoJSONs.common,
            },
            {
                sourceId: this.cuSourceIds_temporary.buildingGeoJSONs.common,
                layerId: this.cuLayerIds_temporary.buildingGeoJSONs.common,
            },
        ];
        const buildingsPersistent = [
            {
                sourceId: this.cuSourceIds.buildingGeoJSONs.persistent,
                layerId: this.cuLayerIds.buildingGeoJSONs.persistent,
            },
            {
                sourceId: this.cuSourceIds_temporary.buildingGeoJSONs.persistent,
                layerId: this.cuLayerIds_temporary.buildingGeoJSONs.persistent,
            },
        ];
        const buildingLabels = [
            {
                sourceId: this.cuSourceIds.buildingsLabels.common,
                layerId: this.cuLayerIds.buildingLabels.common,
            },
        ];
        const masks = [
            {
                sourceId: this.cuSourceIds.maskingGeoJSONs.common,
                layerId: this.cuLayerIds.maskingGeoJSONs.common,
            },
            {
                sourceId: this.cuSourceIds_temporary.maskingGeoJSONs.common,
                layerId: this.cuLayerIds_temporary.maskingGeoJSONs.common,
            },
        ];
        const setProperties = () => {
            grounds.forEach(({ layerId }) => {
                this._map.setPaintProperty(layerId, "fill-color", getIndoorGeoJSONProperties().ground.color);
            });
            outlines.forEach(({ layerId }) => {
                this._map.setPaintProperty(layerId, "fill-color", getIndoorGeoJSONProperties().floors.color);
            });
            rooms.forEach(({ layerId }) => {
                this._map.setPaintProperty(layerId, "fill-extrusion-height", getIndoorGeoJSONProperties().rooms.height);
                this._map.setPaintProperty(layerId, "fill-extrusion-color", getIndoorGeoJSONProperties().rooms.color);
                this._map.setPaintProperty(layerId, "fill-extrusion-vertical-gradient", false);
                this._map.setPaintProperty(layerId, "fill-extrusion-base", getIndoorGeoJSONProperties().rooms.base);
            });
            glassRooms.forEach(({ layerId }) => {
                this._map.setPaintProperty(layerId, "fill-extrusion-height", DEFAULT_STYLING.rooms.height.glassStandard);
                this._map.setPaintProperty(layerId, "fill-extrusion-color", getIndoorGeoJSONProperties().rooms.color);
                this._map.setPaintProperty(layerId, "fill-extrusion-vertical-gradient", false);
                this._map.setPaintProperty(layerId, "fill-extrusion-opacity", DEFAULT_STYLING.rooms.opacity.glass);
            });
            buildings.forEach(({ layerId }) => {
                this._map.setLayoutProperty(layerId, "visibility", getBuildingGeoJSONProperties().layout.visibility);
                this._map.setPaintProperty(layerId, "fill-extrusion-color", getBuildingGeoJSONProperties().paint["fill-extrusion-color"]);
                this._map.setPaintProperty(layerId, "fill-extrusion-height", getBuildingGeoJSONProperties().paint["fill-extrusion-height"]);
            });
            buildingsPersistent.forEach(({ layerId }) => {
                this._map.setLayoutProperty(layerId, "visibility", getBuildingGeoJSONProperties().layout.visibility);
                this._map.setPaintProperty(layerId, "fill-extrusion-color", getBuildingGeoJSONProperties().paint["fill-extrusion-color"]);
                this._map.setPaintProperty(layerId, "fill-extrusion-height", getBuildingGeoJSONProperties().paint["fill-extrusion-height"]);
            });
            //buildingLabels.forEach(({ layerId }) => {
            // TODO NICHT VERGESSEB
            // this._map.setPaintProperty(
            //   layerId,
            //   "text-color",
            //   getCaseProperties({
            //     mapStyleArray_active:
            //       generatedMapStyleJSON?.buildings.symbols.textColors_active,
            //     mapStyleArray: generatedMapStyleJSON?.buildings.symbols.textColors,
            //     defaultFallback: "#000000",
            //   })
            // );
            // TODO NICHT VERGESSEB
            // this._map.setLayoutProperty(
            //   layerId,
            //   "text-size",
            //   getCaseProperties({
            //     mapStyleArray: generatedMapStyleJSON?.buildings.symbols.textSizes,
            //     defaultFallback: 10,
            //   })
            // );
            //});
            masks.forEach(({ layerId }) => {
                this._map.setPaintProperty(layerId, "fill-color", getMaskProperties().paint.fillColor);
            });
        };
        const setInteriorLayers = () => {
            grounds.forEach(({ layerId, sourceId }) => {
                if (!this._map.getLayer(layerId)) {
                    this._map.addLayer({
                        id: layerId,
                        type: "fill",
                        source: sourceId,
                    });
                }
            });
            outlines.forEach(({ layerId, sourceId }) => {
                if (!this._map.getLayer(layerId)) {
                    this._map.addLayer({
                        id: layerId,
                        type: "fill",
                        source: sourceId,
                    }
                    // this.mapOptions?.overInteriorLayerId
                    );
                }
            });
            rooms.forEach(({ layerId, sourceId }) => {
                if (!this._map.getLayer(layerId)) {
                    this._map.addLayer({
                        id: layerId,
                        type: "fill-extrusion",
                        source: sourceId,
                    }
                    // this.mapOptions?.overInteriorLayerId
                    );
                }
            });
            roomsLabels.forEach(({ layerId, sourceId }) => {
                if (!this._map.getLayer(layerId)) {
                    this._map.addLayer({
                        id: layerId,
                        type: "symbol",
                        source: sourceId,
                        filter: [
                            "all",
                            [
                                ">",
                                ["zoom"],
                                this.zoomRanges.roomLabels.start,
                            ],
                            [
                                "!=",
                                ["get", "name"],
                                "kein Raumnamen gefunden",
                            ],
                            showObjectCondition,
                        ],
                        layout: {
                            visibility: "visible",
                            "symbol-sort-key": [
                                "case",
                                ["get", "sortKey"],
                                ["get", "sortKey"],
                                1,
                            ],
                            // "text-size": textSize,
                            "text-size": 14,
                            "text-field": [
                                "case",
                                ["has", "short"],
                                ["get", "short"],
                                ["get", "name"],
                            ],
                            // "text-font": CUSTOMIZABLE_VALUES.facilityTextFont,
                            "text-font": ["Open Sans Semibold", "Arial Unicode MS Regular"],
                        },
                        paint: {
                            "text-translate": [0, 5],
                            // "text-halo-color": CUSTOMIZABLE_VALUES.textHalo,
                            "text-halo-color": "rgba(255,255,255,0.6)",
                            // "text-halo-width": haloWidth,
                            "text-halo-width": 1,
                            "text-color": [
                                "case",
                                // @ts-ignore
                                EXPRESSIONS.state.selected,
                                CUSTOMIZABLE_VALUES.roomText_selected,
                                // "#255fa5",
                                CUSTOMIZABLE_VALUES.roomText,
                                // "#44556b",
                            ],
                        },
                    });
                }
            });
            // Glassrooms haben ihren eigenen Layer, da sie ein Raum (der gleiche Raum übrigens) in dem anderen
            // darstellen
            glassRooms.forEach(({ layerId, sourceId }) => {
                if (!this._map.getLayer(layerId)) {
                    this._map.addLayer({
                        id: layerId,
                        type: "fill-extrusion",
                        source: sourceId,
                        // filter: EXPRESSIONS.roomType.glass as FilterSpecification,
                        filter: [
                            "all",
                            EXPRESSIONS.roomType.glass,
                            [
                                "any",
                                ["!", ["has", "showObject"]],
                                ["!=", ["get", "showObject"], false],
                            ],
                        ],
                    }
                    // this.mapOptions?.overInteriorLayerId
                    );
                }
            });
        };
        const setExteriorLayers = () => {
            buildings.forEach(({ layerId, sourceId }) => {
                if (!this._map.getLayer(layerId)) {
                    this._map.addLayer({
                        id: layerId,
                        type: "fill-extrusion",
                        layout: { visibility: "visible" },
                        source: sourceId,
                        // filter: ["<", ["zoom"], this.zoomRanges.buildings.end], // TODO HIER!
                        filter: [
                            "all",
                            ["<", ["zoom"], this.zoomRanges.buildings.end],
                            [
                                "any",
                                ["!", ["has", "showObject"]],
                                ["!=", ["get", "showObject"], false],
                            ],
                        ],
                    });
                }
            });
            buildingsPersistent.forEach(({ layerId, sourceId }) => {
                if (!this._map.getLayer(layerId)) {
                    this._map.addLayer({
                        id: layerId,
                        type: "fill-extrusion",
                        layout: { visibility: "visible" },
                        source: sourceId,
                        // Buildings Persistent sind immer angezeigt, daher keinen Filter.
                        // filter: ["<", ["zoom"], this.zoomRanges.buildings.end], // TODO HIER!
                        filter: ["!=", ["get", "showObject"], false],
                    });
                }
            });
            buildingLabels.forEach(({ sourceId, layerId }) => {
                if (!this._map.getLayer(layerId)) {
                    this._map.addLayer({
                        id: layerId,
                        type: "symbol",
                        source: sourceId,
                        // filter: [
                        //   "all",
                        //   ["<", ["zoom"], this.zoomRanges.buildings.end],
                        //   ["has", "name"],
                        // ],
                        filter: [
                            "all",
                            ["<", ["zoom"], this.zoomRanges.buildings.end],
                            ["has", "name"],
                            [
                                "any",
                                ["!", ["has", "showObject"]],
                                ["!=", ["get", "showObject"], false],
                            ],
                        ],
                        layout: {
                            "text-field": ["get", "name"],
                            "icon-image": [
                                "coalesce",
                                // Check if the styleId has an image uploaded
                                ["image", ["concat", "styleId_", ["get", "styleId"]]],
                                // If no image with the name above exists, show the
                                // "default_buildingLabelIcon" image instead.
                                ["image", "default_buildingLabelIcon"],
                            ],
                            "icon-text-fit": "both",
                            "icon-text-fit-padding": [2, 10, 2, 10],
                        },
                    });
                }
            });
            this._setBuildingGeoJSONFade();
        };
        const setMiscLayers = () => {
            masks.forEach(({ layerId, sourceId }) => {
                if (!this._map.getLayer(layerId)) {
                    this._map.addLayer({
                        id: layerId,
                        source: sourceId,
                        type: "fill",
                    });
                }
            });
        };
        if (init) {
            setMiscLayers();
            setInteriorLayers();
            setExteriorLayers();
        }
        // Needs loaded mapstyles, or bad style.
        setTimeout(() => {
            setProperties();
        }, 100);
    }
    /** This lets the buildings fade in and out of visibility while zooming */
    _setBuildingGeoJSONFade() {
        this._map.off("zoom", this._onZoomHandler);
        this._map.on("zoom", this._onZoomHandler);
    }
}
